import { ReactNode } from 'react'
import { Box, Typography } from '@mui/material'
import { StaticImageData } from 'next/image'

import CloudflareImage from '@ecm/ui/element/CloudflareImage'
import Color from '@ecm/ui/element/Color'
import MainContainer from '@ecm/ui/element/MainContainer'

type KeepMailGeenProps = {
  steps: {
    icon: StaticImageData
    label: ReactNode
  }[]
  heading: string
  subHeading?: string
} & React.ComponentProps<typeof Box>

const KeepMailGreen = ({ steps, heading, subHeading, ...otherProps }: KeepMailGeenProps) => (
  <Box bgcolor={Color.smoke.lightest} {...otherProps}>
    <MainContainer
      sx={{
        pb: '2em',
      }}
    >
      <Typography variant="h3" component="h2" margin="0 0 2em" maxWidth="500px">
        {heading}
      </Typography>

      {subHeading && (
        <Typography
          variant="h5"
          component="h3"
          margin="2em 0 1em"
          textAlign="center"
          display={{ md: 'block', xs: 'none' }}
        >
          {subHeading}
        </Typography>
      )}

      <Box
        display="grid"
        gap="1.5em"
        gridTemplateColumns={{ md: 'repeat(3, 1fr)', sm: '1fr' }}
        py="1em"
        justifyItems={{ md: 'unset', xs: 'center' }}
      >
        {steps.map((item, index) => (
          <Box
            key={index}
            p="1em"
            textAlign="center"
            bgcolor={Color.white.normal}
            borderRadius="16px"
            maxWidth={{ md: 'unset', xs: '350px' }}
          >
            <CloudflareImage src={item.icon} />
            <Typography variant="p2" color={Color.saint.normal}>
              {item.label}
            </Typography>
          </Box>
        ))}
      </Box>
    </MainContainer>
  </Box>
)

export default KeepMailGreen
